import Api from "lib/api/httpRequestHelper";

import { unwrapApiResult } from "../../monitoramento-preco/components/mpMappers";

export function normalizeFotoBase64Src(fotoBase64) {
  if (fotoBase64 == null || fotoBase64 === "") return "";
  const value = String(fotoBase64).trim();
  if (!value) return "";
  if (value.startsWith("data:")) return value;
  return `data:image/jpeg;base64,${value}`;
}

export function resolveColetaFotoSrc(raw) {
  const fotoUrl = raw?.fotoUrl ?? raw?.FotoUrl ?? "";
  if (fotoUrl) return String(fotoUrl).trim();

  const fotoBase64 = raw?.fotoBase64 ?? raw?.FotoBase64 ?? "";
  return normalizeFotoBase64Src(fotoBase64);
}

export default async function fetchConcorrenteFoto(
  idColeta,
  idProdutoConcorrente,
) {
  const response = await Api.get(
    `coletas/${idColeta}/concorrentes/${idProdutoConcorrente}/foto`,
    "priceMonitoring",
    "",
    true,
  );
  const raw = unwrapApiResult(response);
  const src = resolveColetaFotoSrc(raw);
  if (!src) {
    throw new Error("Foto não disponível.");
  }
  return src;
}
